export const MaintenanceCompletePage = () => {
  return <>MaintenanceCompletePage</>;
};
